import * as React from 'react';
import styles from 'containers/Layouts/Layout.module.css';
import i18n from 'i18n/I18nInstance';
import { Flag } from 'config/featureFlags/flagsConfig';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/GetApp';
import PrintIcon from '@mui/icons-material/Print';

interface IProps {
    downloadHandler?: (event) => void;
    printHandler?: (event) => void;
    showActionButtons?: boolean;
    title?: string;
}

export default function ActionButtons(props: IProps) {
    const i18n_download = i18n.translator.formatMessage({
        id: 'common.Download',
        defaultMessage: 'Download',
    });
    const i18n_print = i18n.translator.formatMessage({
        id: 'common.Print',
        defaultMessage: 'Print',
    });

    return (
        <React.Fragment>
            {!props.showActionButtons ? null : (
                <div data-qaid="actionButtons" className={styles.actionButtonContainer}>
                    <Flag name={['actionButtons', 'download']}>
                        <IconButton
                            title={i18n_download}
                            aria-label={`${i18n_download} ${props.title}`}
                            onClick={props.downloadHandler}
                            className={styles.actionButton}
                            data-qaid="actionButtonDownload"
                        >
                            <DownloadIcon />
                        </IconButton>
                    </Flag>
                    <IconButton
                        title={i18n_print}
                        aria-label={`${i18n_print} ${props.title}`}
                        className={styles.actionButton}
                        onClick={props.printHandler}
                        data-qaid="actionButtonPrint"
                    >
                        <PrintIcon />
                    </IconButton>
                </div>
            )}
        </React.Fragment>
    );
}

ActionButtons.defaultProps = {
    showActionButtons: true,
};
